import { GetCondensados, PutAutorizar } from "./ExpedienteValidacion.store";
import * as actions from "../../actions/expedientes";
import { Preview } from "../../../types/IAction";

export interface ExpedienteValidacionDispatcher {
  getCondensados: (filters: any) => Promise<Preview<GetCondensados>>;
  putAutorizar: (idExpediente: number) => Promise<Preview<PutAutorizar>>;
}

export const expedienteValidacionDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ExpedienteValidacionDispatcher = dispatch => ({
  getCondensados: (filters: any) => {
    return dispatch(actions.getCondensados(filters));
  },
  putAutorizar: (idExpediente: number) => {
    return dispatch(actions.putAutorizar(idExpediente));
  }
});
